module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selected-filter-row"
  }, [_c('div', {
    staticClass: "uk-flex-inline uk-flex-wrap uk-card uk-card-default uk-card-small uk-card-body",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v(_vm._s(_vm.property.name) + ": ")]), _vm._v(" "), _vm._l((_vm.propertyValues), function(propertyValue) {
    return _c('div', {
      key: propertyValue.id,
      staticClass: "uk-flex uk-flex-center uk-flex-bottom"
    }, [_c('label', [_vm._v(" " + _vm._s(propertyValue.value_varchar) + " "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedPropertyValues),
        expression: "checkedPropertyValues"
      }],
      staticClass: "uk-checkbox uk-margin-xsmall-right",
      staticStyle: {
        "margin-top": "0"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": propertyValue.id,
        "checked": Array.isArray(_vm.checkedPropertyValues) ? _vm._i(_vm.checkedPropertyValues, propertyValue.id) > -1 : (_vm.checkedPropertyValues)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.checkedPropertyValues,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = propertyValue.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedPropertyValues = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedPropertyValues = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedPropertyValues = $$c
          }
        }, _vm.reset]
      }
    })])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63fcdc15","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Filter/SelectedShopFilterRow.vue
// module id = 83
// module chunks = 0